module.exports = __webpack_public_path__ + "img/Katarina_home_05.5d117515.jpg";